module.exports = __webpack_public_path__ + "ce43bbb745c332320d18b653b39973b3.MP3";